import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import { banners } from '../data/dummyData';

const Banners = () => {
  const [bannerList] = useState(banners);

  const columns = [
    { key: 'title', label: 'Title', sortable: true },
    { key: 'description', label: 'Description', sortable: false },
    { key: 'startDate', label: 'Start Date', sortable: true },
    { key: 'endDate', label: 'End Date', sortable: true },
    {
      key: 'status',
      label: 'Status',
      render: (val) => (
        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
          val === 'active'
            ? 'bg-green-100 text-green-700'
            : 'bg-gray-100 text-gray-700'
        }`}>
          {val.charAt(0).toUpperCase() + val.slice(1)}
        </span>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Banner Management"
        description="Manage promotional banners"
        breadcrumbs={['Home', 'Banners']}
      />

      <DataTable
        columns={columns}
        data={bannerList}
        searchable={true}
        paginate={true}
        itemsPerPage={10}
      />
    </div>
  );
};

export default Banners;
